<template>
  <div>
    <div :class="{ appcontainer: true, fullScreen: isFullscreen }">
      <transition mode="out-in">
        <router-view />
      </transition>
    </div>
    <AppMenu>
      <template v-slot:topextremeleft v-if="!isFullscreen">
        <RoundButton class="homeButton" href="/" width="60" image="ic-home.svg" />
      </template>
      <template v-slot:topleft v-if="!isFullscreen">
        <div class="container-title">
          <RoundButton
            v-if="isVideoYoutubeLink"
            class="bordered back"
            href="/products"
            width="32"
            image="ic-arrow-back.svg"
          />
          <RoundButton v-else class="bordered back" href="/Understand" width="32" image="ic-arrow-back.svg" />
          <div class="container-title align" v-if="isVideoYoutubeLink">
            <h2 class="titleCategory">
              {{ getWebcontrol($route.params.title) !== '' ? getWebcontrol($route.params.title) : $route.params.title }}
            </h2>
          </div>
          <div class="container-title align" v-else>
            <h2 class="titleCategory">{{ getCategory }}</h2>
            <h2 class="titleCategory">•</h2>
            <h2 class="titleVideo">{{ getNameVideo }}</h2>
          </div>
        </div>
      </template>
      <template v-slot:topright v-if="isFullscreen">
        <RoundButton
          class="bordered close-fullscreen backbutton"
          v-on:go="exitFullscreen"
          width="35"
          image="ic-close.svg"
        />
      </template>
      <template v-slot:bottomrightincontainer v-if="!isFullscreen">
        <img src="../assets/logo.png" width="176" height="72" />
      </template>
    </AppMenu>
  </div>
</template>

<script>
import AppMenu from '@Components/Menu';
import RoundButton from '@Components/Menus/RoundButton';

export default {
  components: {
    AppMenu,
    RoundButton,
  },
  data() {
    return {
      isFullscreen: false,
    };
  },
  computed: {
    isVideoYoutubeLink() {
      return this.$route.params.youtubeId !== undefined;
    },
    getCategory() {
      return this.$route.params.category;
    },
    getNameVideo() {
      return this.$route.params.nameVideo;
    },
  },
  methods: {
    getWebcontrol(key) {
      return this.$store.getters.getValueById(key);
    },
    // Exit fullscreen
    exitFullscreen() {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        /* Firefox */
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        /* Chrome, Safari and Opera */
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        /* IE/Edge */
        document.msExitFullscreen();
      }
      this.isFullscreen = false;
      //Reset height
      document.querySelectorAll('video').forEach(video => {
        video.style.height = '87vh';
      });
      //Reset the padding style
      document.querySelector('#app').style.padding = null;
    },
    // Enter in fullscreen
    fullscreen() {
      const elem = document.querySelector('#app');
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.mozRequestFullScreen) {
        /* Firefox */
        elem.mozRequestFullScreen();
      } else if (elem.webkitRequestFullscreen) {
        /* Chrome, Safari and Opera */
        elem.webkitRequestFullscreen();
      } else if (elem.msRequestFullscreen) {
        /* IE/Edge */
        elem.msRequestFullscreen();
      }

      this.isFullscreen = true;

      if (document.querySelector('iframe')) {
        document.querySelector('iframe').requestFullscreen();
      }
    },
  },
};
</script>

<style scoped>
.formfield-select {
  position: relative;
  font-family: AkhandSoft;
  display: flex;
  justify-content: center;
  align-items: center;
}
.align {
  align-self: center;
  padding-left: 20px;
}
.fullScreen {
  width: 100%;
}
.appcontainer {
  position: absolute;
  top: 11vh;
  bottom: 11vh;
  left: 7vw;
  right: 7vw;
  display: flex;
  justify-content: center;
  align-items: center;
}
.fullScreen.appcontainer {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}

* {
  font-family: 'AkhandSoft', Helvetica, Arial, sans-serif;
}

.leftMenuButton img svg path {
  fill: white !important;
}

.container-title {
  display: flex;
  display: -webkit-flex;
  display: -moz-flex;
}

.leftMenuButton:hover,
.leftMenuButton.active {
  background-color: #0088ec;
}

.bordered.close-fullscreen {
  background-color: white;
  border-radius: 100px;
  border: 1px grey solid;
}

.backbutton {
  position: absolute;
}

.titleCategory {
  color: #5e6a71;
  padding-right: 10px;
}
.titleVideo {
  color: black;
}

button {
  border: none;
  background-color: transparent;
}
</style>
